module.exports = __webpack_public_path__ + "media/components/videos_internal/dr_you_6_1-burger3-c7bf1875f13122dadb59a0fa2d5f9af1.jpg";